module.exports = __webpack_public_path__ + "assets/img/img-welfare-01.c3fac113.jpg";